<template>
  <v-card height="100%" to="/strategic-anchors">
    <v-card-title> Company Strategic Anchors </v-card-title>
    <v-card-subtitle>
      Manage and monitor your companies strategic anchors
    </v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-simple-table>
            <tbody>
              <tr v-for="(sa, i) in strategic_anchors" :key="i">
                <td>
                  {{ sa.name }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "StrategicAnchorCard",
  components: {},
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({
      strategic_anchors: "company/strategic_anchors",
      is_admin: "profile/is_admin"
    })
  },
  created() {},
  methods: {}
};
</script>
